export default {
      id: "ic_read_announcements_close-usage",
      viewBox: "0 0 15 12",
      url: "/" + "images/icons.3.109.2.svg#ic_read_announcements_close-usage",
      toString: function () {
        return this.url;
      }
    }